import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import "core-js/modules/es.array.reduce-right.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { getDomNodePagePosition } from '../../../base/browser/dom.js';
import { Action, Separator } from '../../../base/common/actions.js';
import { canceled } from '../../../base/common/errors.js';
import { Lazy } from '../../../base/common/lazy.js';
import { Disposable, MutableDisposable } from '../../../base/common/lifecycle.js';
import { Position } from '../../common/core/position.js';
import { CodeActionProviderRegistry } from '../../common/modes.js';
import { codeActionCommandId, fixAllCommandId, organizeImportsCommandId, refactorCommandId, sourceActionCommandId } from './codeAction.js';
import { CodeActionCommandArgs, CodeActionKind } from './types.js';
import { IContextMenuService } from '../../../platform/contextview/browser/contextView.js';
import { IKeybindingService } from '../../../platform/keybinding/common/keybinding.js';

var CodeActionAction = /*#__PURE__*/function (_Action) {
  _inherits(CodeActionAction, _Action);

  var _super = _createSuper(CodeActionAction);

  function CodeActionAction(action, callback) {
    var _this;

    _classCallCheck(this, CodeActionAction);

    _this = _super.call(this, action.command ? action.command.id : action.title, action.title, undefined, !action.disabled, callback);
    _this.action = action;
    return _this;
  }

  return CodeActionAction;
}(Action);

var CodeActionMenu = /*#__PURE__*/function (_Disposable) {
  _inherits(CodeActionMenu, _Disposable);

  var _super2 = _createSuper(CodeActionMenu);

  function CodeActionMenu(_editor, _delegate, _contextMenuService, keybindingService) {
    var _this2;

    _classCallCheck(this, CodeActionMenu);

    _this2 = _super2.call(this);
    _this2._editor = _editor;
    _this2._delegate = _delegate;
    _this2._contextMenuService = _contextMenuService;
    _this2._visible = false;
    _this2._showingActions = _this2._register(new MutableDisposable());
    _this2._keybindingResolver = new CodeActionKeybindingResolver({
      getKeybindings: function getKeybindings() {
        return keybindingService.getKeybindings();
      }
    });
    return _this2;
  }

  _createClass(CodeActionMenu, [{
    key: "isVisible",
    get: function get() {
      return this._visible;
    }
  }, {
    key: "show",
    value: function show(trigger, codeActions, at, options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var actionsToShow, menuActions, anchor, resolver;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                actionsToShow = options.includeDisabledActions ? codeActions.allActions : codeActions.validActions;

                if (actionsToShow.length) {
                  _context.next = 4;
                  break;
                }

                this._visible = false;
                return _context.abrupt("return");

              case 4:
                if (this._editor.getDomNode()) {
                  _context.next = 7;
                  break;
                }

                // cancel when editor went off-dom
                this._visible = false;
                throw canceled();

              case 7:
                this._visible = true;
                this._showingActions.value = codeActions;
                menuActions = this.getMenuActions(trigger, actionsToShow, codeActions.documentation);
                anchor = Position.isIPosition(at) ? this._toCoords(at) : at || {
                  x: 0,
                  y: 0
                };
                resolver = this._keybindingResolver.getResolver();

                this._contextMenuService.showContextMenu({
                  domForShadowRoot: this._editor.getDomNode(),
                  getAnchor: function getAnchor() {
                    return anchor;
                  },
                  getActions: function getActions() {
                    return menuActions;
                  },
                  onHide: function onHide() {
                    _this3._visible = false;

                    _this3._editor.focus();
                  },
                  autoSelectFirstItem: true,
                  getKeyBinding: function getKeyBinding(action) {
                    return action instanceof CodeActionAction ? resolver(action.action) : undefined;
                  }
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "getMenuActions",
    value: function getMenuActions(trigger, actionsToShow, documentation) {
      var _this4 = this;

      var _a, _b;

      var toCodeActionAction = function toCodeActionAction(action) {
        return new CodeActionAction(action, function () {
          return _this4._delegate.onSelectCodeAction(action);
        });
      };

      var result = actionsToShow.map(toCodeActionAction);

      var allDocumentation = _toConsumableArray(documentation);

      var model = this._editor.getModel();

      if (model && result.length) {
        var _iterator = _createForOfIteratorHelper(CodeActionProviderRegistry.all(model)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var provider = _step.value;

            if (provider._getAdditionalMenuItems) {
              allDocumentation.push.apply(allDocumentation, _toConsumableArray(provider._getAdditionalMenuItems({
                trigger: trigger.type,
                only: (_b = (_a = trigger.filter) === null || _a === void 0 ? void 0 : _a.include) === null || _b === void 0 ? void 0 : _b.value
              }, actionsToShow)));
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      if (allDocumentation.length) {
        result.push.apply(result, [new Separator()].concat(_toConsumableArray(allDocumentation.map(function (command) {
          return toCodeActionAction({
            title: command.title,
            command: command
          });
        }))));
      }

      return result;
    }
  }, {
    key: "_toCoords",
    value: function _toCoords(position) {
      if (!this._editor.hasModel()) {
        return {
          x: 0,
          y: 0
        };
      }

      this._editor.revealPosition(position, 1
      /* Immediate */
      );

      this._editor.render(); // Translate to absolute editor position


      var cursorCoords = this._editor.getScrolledVisiblePosition(position);

      var editorCoords = getDomNodePagePosition(this._editor.getDomNode());
      var x = editorCoords.left + cursorCoords.left;
      var y = editorCoords.top + cursorCoords.top + cursorCoords.height;
      return {
        x: x,
        y: y
      };
    }
  }]);

  return CodeActionMenu;
}(Disposable);

CodeActionMenu = __decorate([__param(2, IContextMenuService), __param(3, IKeybindingService)], CodeActionMenu);
export { CodeActionMenu };
export var CodeActionKeybindingResolver = /*#__PURE__*/function () {
  function CodeActionKeybindingResolver(_keybindingProvider) {
    _classCallCheck(this, CodeActionKeybindingResolver);

    this._keybindingProvider = _keybindingProvider;
  }

  _createClass(CodeActionKeybindingResolver, [{
    key: "getResolver",
    value: function getResolver() {
      var _this5 = this;

      // Lazy since we may not actually ever read the value
      var allCodeActionBindings = new Lazy(function () {
        return _this5._keybindingProvider.getKeybindings().filter(function (item) {
          return CodeActionKeybindingResolver.codeActionCommands.indexOf(item.command) >= 0;
        }).filter(function (item) {
          return item.resolvedKeybinding;
        }).map(function (item) {
          // Special case these commands since they come built-in with VS Code and don't use 'commandArgs'
          var commandArgs = item.commandArgs;

          if (item.command === organizeImportsCommandId) {
            commandArgs = {
              kind: CodeActionKind.SourceOrganizeImports.value
            };
          } else if (item.command === fixAllCommandId) {
            commandArgs = {
              kind: CodeActionKind.SourceFixAll.value
            };
          }

          return Object.assign({
            resolvedKeybinding: item.resolvedKeybinding
          }, CodeActionCommandArgs.fromUser(commandArgs, {
            kind: CodeActionKind.None,
            apply: "never"
            /* Never */

          }));
        });
      });
      return function (action) {
        if (action.kind) {
          var binding = _this5.bestKeybindingForCodeAction(action, allCodeActionBindings.getValue());

          return binding === null || binding === void 0 ? void 0 : binding.resolvedKeybinding;
        }

        return undefined;
      };
    }
  }, {
    key: "bestKeybindingForCodeAction",
    value: function bestKeybindingForCodeAction(action, candidates) {
      if (!action.kind) {
        return undefined;
      }

      var kind = new CodeActionKind(action.kind);
      return candidates.filter(function (candidate) {
        return candidate.kind.contains(kind);
      }).filter(function (candidate) {
        if (candidate.preferred) {
          // If the candidate keybinding only applies to preferred actions, the this action must also be preferred
          return action.isPreferred;
        }

        return true;
      }).reduceRight(function (currentBest, candidate) {
        if (!currentBest) {
          return candidate;
        } // Select the more specific binding


        return currentBest.kind.contains(candidate.kind) ? candidate : currentBest;
      }, undefined);
    }
  }]);

  return CodeActionKeybindingResolver;
}();
CodeActionKeybindingResolver.codeActionCommands = [refactorCommandId, codeActionCommandId, sourceActionCommandId, organizeImportsCommandId, fixAllCommandId];